
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import * as React from 'react';

var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SvgCloseCircled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.25A7.749 7.749 0 004.25 12 7.749 7.749 0 0012 19.75 7.749 7.749 0 0019.75 12 7.749 7.749 0 0012 4.25zm0 14A6.248 6.248 0 015.75 12 6.248 6.248 0 0112 5.75 6.248 6.248 0 0118.25 12 6.248 6.248 0 0112 18.25zm3.181-8.194a.375.375 0 000-.531l-.706-.706a.375.375 0 00-.531 0L12 10.763l-1.944-1.944a.375.375 0 00-.531 0l-.706.706a.375.375 0 000 .531L10.762 12l-1.943 1.944a.375.375 0 000 .531l.706.706a.375.375 0 00.531 0L12 13.237l1.944 1.944a.375.375 0 00.531 0l.706-.706a.375.375 0 000-.531L13.237 12z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}

export { SvgCloseCircled as default };
//# sourceMappingURL=close-circled.svg.js.map
